class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.dispatchEvent(new Event('clc:cart-confirmation-closed'));
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, addedQuantity = parsedState.quantity) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    const amount=document.querySelector('#cart-notification-product [data-added-amount]');
    if(amount && Number.isSafeInteger(addedQuantity) && addedQuantity>0){
      const addedPieces=addedQuantity*(Number(amount.dataset.piecesPerUnit)||1);
      amount.querySelector('[data-added-pieces]').textContent=addedPieces+'x caps';
      const current = document.querySelector('#cart-notification-product [data-added-current]');
      const reference = document.querySelector('#cart-notification-product [data-added-reference]');
      const savings = document.querySelector('#cart-notification-product [data-added-savings]');
      const lineQuantity = Number(current?.dataset.lineQuantity);
      if (current && reference && lineQuantity > 0) {
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: amount.dataset.currency, currencyDisplay: 'narrowSymbol'
        });
        const addedTotal = Math.round(Number(current.dataset.linePrice) * addedQuantity / lineQuantity);
        const addedReference = Number(reference.dataset.unitReference) * addedQuantity;
        current.textContent = money.format(addedTotal / 100);
        reference.textContent = money.format(addedReference / 100);
        reference.hidden = addedReference <= addedTotal;
        if (savings) {
          savings.textContent = 'Saved: ' + money.format((addedReference - addedTotal) / 100);
          savings.hidden = addedReference <= addedTotal;
        }
      }
    }
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

